import { formatDateShort } from '~/lib/DateTime';
import { StatusBadge } from '~/components/packages/GrantList';
import { humanGrantRedeemableAmount } from '~/lib/PackageHelpers';
import React from 'react';

const SinglePackage = ({ grant, isFirst }) => {
    const expires = grant?.expires_at
        ? formatDateShort(grant?.expires_at)
        : 'No expiration';

    return (
        <div
            className={`${!isFirst ? 'border-t' : ''} py-3 pr-4 flex items-center justify-between `}
        >
            <div className="flex-1">
                {grant?.package?.name || 'Unknown Package'}
            </div>
            <div className="flex-1">
                <StatusBadge grant={grant} />
            </div>
            <div className="flex-1">
                {humanGrantRedeemableAmount(grant)}
                <div className="text-sm sm:hidden">{expires}</div>
            </div>
            <div className="flex-1 hidden sm:block">{expires}</div>
        </div>
    );
};

const PackageHistory = ({ packages }) => {
    return (
        <div>
            {packages.length > 0 && (
                <div className="flex items-center justify-between mx-6">
                    <div className="flex-1 column-label">Package</div>
                    <div className="flex-1 column-label">Status</div>
                    <div className="flex-1 column-label">Remaining</div>
                    <div className="flex-1 column-label hidden sm:block">
                        Expires
                    </div>
                </div>
            )}

            <div className="panel pl-4">
                {packages.length === 0 && (
                    <div className="py-3">You have no packages</div>
                )}
                {packages.map((grant, idx) => (
                    <SinglePackage grant={grant} isFirst={idx === 0} />
                ))}
            </div>
        </div>
    );
};

export default PackageHistory;
